import { Card } from '../../../Common/Charts/Card';
import { number } from '../../../Common/Util/number';
import { usePeopleWithDisabilitiesChartsDataContext } from './hooks/usePeopleWithDisabilitiesChartsDataContext';

export const Indicators = () => {
    const { chartData } = usePeopleWithDisabilitiesChartsDataContext();

    return (
        <div className="w-100" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <Card
                title="Total de Pessoas com Deficiência" 
                value={number.formatToBRNumber(
                    chartData?.indicators?.peopleWithDisabilities || 0
                )}
            />
            <Card
                title="Média de Deficiêncientes por Família"
                value={number.formatToBRNumber(
                    chartData?.indicators?.averageOfDisabledPerFamily || 0
                )}
            />
        </div>
    );
};
